<ng-container *ngIf="tableParams$ | async as tableParams">
  <markant-filter-group
    class="toolbar"
    [clearText]="'common.clearAll' | transloco"
    [excludeSearchbar]="true"
    (filter)="onResetFilters($event.detail)"
  >
    <markant-searchbar
      placeholder="{{ 'common.search' | transloco }}"
      [value]="tableParams.searchQuery"
      [debounce]="300"
      (valueChange)="onSearchChange($event.detail)"
    >
    </markant-searchbar>

    @for (group of filter | keyvalue: keepOrder; track group.key) {
      <markant-filter-select
        data-cy="organization-bookings-table-filter-select"
        [name]="group.key"
        [apply]="'common.apply' | transloco"
        [reset]="'common.reset' | transloco"
        [representation]="group.value.translationKey | defaultValue | transloco"
        [appliedFilters]="tableParams.activeFilter[group.key] || []"
        [searchbar]="
          group.value.filterOptions.length >
          DEFAULT_THRESHOLD_FOR_SEARCHABLE_FILTER
        "
        [options]="
          group.value.searchedFilterOptions
            ? group.value.searchedFilterOptions
            : group.value.filterOptions
        "
        (filterChange)="onFilterGroupChange($event.detail, group.key)"
        (searchbarValueChange)="
          onSearchbarValueChange($event.detail, group.value)
        "
      >
      </markant-filter-select>
    }

    <span slot="markant-filter-group-amount">
      {{ totalCount }}
      {{ 'common.results' | transloco }}
    </span>
  </markant-filter-group>

  <markant-platform-table
    [data]="tableData$ | async"
    [defaultHeaderCells]="tableDraft.headerAndTableCells"
    [totalCount]="totalCount"
    [pageIndex]="tableParams.page.index"
    [pageSize]="tableParams.page.size"
    [showPagination]="true"
    (indexChanged)="onIndexChange($event)"
    (pageSizeChanged)="onPageSizeChange($event)"
    (sortChanged)="onSortChange($event)"
  >
  </markant-platform-table>
</ng-container>
